import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators} from '@angular/forms'; //FormGroup, FormControl,
import { Router } from '@angular/router'; //, NavigationExtras

import { UserProvider } from '../providers/user/user';
import { BasicProvider } from '../providers/basic/basic';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {

  form_heading = 'My Home Address';
  home_address=[];
  shiping_address=[];
  saveaddress = 'home';
  showAddbutton = true;
  address_error = '';

  addressForm;
  fromData;
  addAddres = true;
  countries:any;
  states:any;
  
  validation_message = {
    'country_id': {
      'required': 'Please select country.'
    },
    'island_id': {
      'required': 'Please select Island/Parish.'
    },
    'address': {
      'required': 'Please provide address.'
    },
    'city': {
      'required': 'Please provide city.'
    },
    'phone': {
      'required': 'Please provide phone number.',
      'pattern': 'Please enter valid phone.',
      'minlength': 'phone number length must be between 8 to 10.',
      'maxlength': 'phone number length must be between 8 to 10.'
    }
  };

  constructor(
    public bp:BasicProvider, 
    public up:UserProvider,
    public builder:FormBuilder,
    public router: Router,
  ) { 

  }

  ngOnInit() {
    this.getData();
    this.showAddButtonHeader();
    //this.getCountryData();
    this.addressValidate();
  }
  
  

  addressValidate() {
    this.address_error = '';
    this.addAddres = true;
    this.addressForm = this.builder.group({
      country_id: ['', Validators.compose([this.bp.required])], 
      island_id: ['', Validators.compose([this.bp.required])], 
      address: ['', Validators.compose([this.bp.required])], 
      city: ['', Validators.compose([this.bp.required])], 
      'phone': ['', Validators.compose([this.bp.required, Validators.pattern(/^[0-9]+/), Validators.minLength(8), Validators.maxLength(10)])], 
      comments: [''] 
    });
  }

  

  getData(){
    this.home_address=[];
    this.shiping_address=[];
    if(true || !this.up.isContryData){
      this.bp.hitApi('users/user_address', 'GET', {}, true, true)
      .subscribe(
        success => { 
          if( success.type == true ){ 
			
            for(let i=0; i<success.data.length; i++){
              if (success.data[i].address_type == 'Home') {
                this.home_address.push(success.data[i]);
              } else {
                this.shiping_address.push(success.data[i]);
              }
            }
			      this.getCountryData();
            this.showAddButtonHeader();
          }
          else {
            this.bp.show_toast('Error',success.message); 
          }
        },
        error => {
          console.log(error);
        }
      );
    }
      
  }

  

  changeCountry(e: any){
    this.addressForm.controls['island_id'].setValue('');
    this.states = this.up.getState(e);
  }

  editAddress(data){
    this.addAddres = false;
    this.changeCountry(data.country_id);
    this.address_error = '';
    console.log(data);
    this.fromData = data;
    this.addressForm = this.builder.group({
      country_id: [data.country_id, Validators.compose([this.bp.required])], 
      island_id: [data.island_id, Validators.compose([this.bp.required])], 
      address: [data.address, Validators.compose([this.bp.required])], 
      city: [data.city, Validators.compose([this.bp.required])], 
      'phone': [data.phone, Validators.compose([this.bp.required, Validators.pattern(/^[0-9]+/), Validators.minLength(8), Validators.maxLength(10)])], 
      comments: [data.comments] 
    });
  }

  deleteAddress(data){
    if(this.home_address.length<2){
      this.bp.show_toast('Error','You need to save atleast one address.'); 
      return false;
    }

    if(confirm("Do you want to delete this address?")) {
      this.bp.hitApi('users/delete_address', 'POST', {address_id:data.id}, true, true) 
      .subscribe(
        success => {
          if (success.type == true) {
            this.bp.show_toast('Success',success.message); 
            this.getData();
          } else {
            this.bp.show_toast('Error',success.message); 
          }
        }, 
        error => {}
      );
    }
    
  }

  getCountryData(){
    
    if(true || !this.up.isContryData){
      this.bp.hitApi('settings/get_country_island', 'GET', {},false)
      .subscribe(
        success => { 
          if( success.type == true ){
            this.up.countryData = success.data; 
            this.countries = this.up.getCountry(); 
          } else {
            this.bp.show_toast('Error',success.message);  
          } 
        }, 
        error => {
          console.log(error);
        }
      );
    }
    else{
      //this.countries = this.up.getCountry();
    }
  }

  async addForm() {

    if(!this.showAddbutton){
      this.bp.show_toast('Error','You can\'t add more than 2 home address.');
      return false;
    }

    if (this.bp.validation(this.addressForm, this.validation_message)) {

      

      this.address_error = '';
      let submitData = this.addressForm.value;
      var data = this.addAddressData(submitData);
      //console.log(data);
      this.bp.hitApi('users/save_address', 'POST', data, true, true)
        .subscribe(
          success => {
            if (success.type == true) {
              this.addressValidate();
              this.up.setUserAddressCount('home_address','1');
              this.bp.show_toast('Success',success.message);
              this.getData();
            } else {
              this.bp.show_toast('Error',success.message);
            }
          }, 
          error => {

          }
        );
    } else {
      this.address_error = this.bp.validation_error;
    }
  }

  addAddressData(data){
    let submitData = data;
    submitData.address_type = 'Home';
    let address = [];
    address.push(submitData);
    return Object.assign({}, {address:address});
  }

  async updateForm() {

    if (this.bp.validation(this.addressForm, this.validation_message)) {
      this.address_error = '';
      let submitData = this.addressForm.value;
      var data = this.updateAddressData(submitData);
      console.log(data);
      this.bp.hitApi('users/update_address', 'POST', data, true, true)
        .subscribe(
          success => {
            if (success.type == true) {
              this.addressValidate();
              this.bp.show_toast('Success',success.message); 
              this.getData();
            } else {
              this.bp.show_toast('Error',success.message); 
            }
          }, 
          error => {

          }
        );
    } else {
      this.address_error = this.bp.validation_error;
    }
  }

  updateAddressData(data){
    let submitData = data;
    submitData.address_type = 'Home';
    let address = [];
    address.push(submitData);
    return Object.assign({}, {address:address},{address_id:this.fromData.id});
  }

  showAddButtonHeader(){
    if(this.saveaddress == 'home' && this.home_address.length<2){
      this.showAddbutton = true;
    }
    else {
      this.showAddbutton = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/address/address.component.ts